import React from "react";

function Card() {
  return (
    <div className="card-div">
      <div className="emoji">😂</div>
      <div className="emojiName">Face with tears of joy</div>
      <div className="emoji-description">
        A yellow face with a big grin, uplifted eyebrows, and smiling eyes, each
        shedding a tear from laughing so hard. Widely used to show something is
        funny or pleasing.
      </div>
    </div>
  );
}

export default Card;
